import keyd from 'keyd';
import Logger from '../utilities/logger';
export const name = 'ConfigurationLoader';
export const configurationKey = 'durangoConfiguration';
class ConfigurationLoader {
    static set(key, value) {
        ConfigurationLoader.loadConfig();
        if (typeof keyd(ConfigurationLoader.config).get(key) === 'undefined') {
            keyd(ConfigurationLoader.config).set(key, value);
        }
        else {
            Logger.warn(`Attempted to modify an immutable config path: ${key}`);
        }
    }
    static get(key) {
        ConfigurationLoader.loadConfig();
        return keyd(ConfigurationLoader.config).get(key);
    }
    static loadConfig() {
        if (typeof ConfigurationLoader.config === 'undefined') {
            ConfigurationLoader.config = globalThis[configurationKey];
            if (typeof ConfigurationLoader.config === 'undefined') {
                ConfigurationLoader.config = {};
                Logger.warn(`Unable to load Configuration object from globalThis['${configurationKey}']`);
            }
        }
    }
    static getConfig() {
        ConfigurationLoader.loadConfig();
        return ConfigurationLoader.config;
    }
    static reset() {
        ConfigurationLoader.config = undefined;
    }
}
export default ConfigurationLoader;
